import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";

import {
  getLimitedRelationships,
  getRelationships,
} from "../../data/services/form_contract";

import RelationshipModel from "../../data/models/relationship";

import {
  AddDependentsButton,
  DependentsList,
  PageContainer,
  SendChangeRequestButton,
  StyledButton,
} from "../../styles/SelectDependents";
import { DependentsButton } from "../../styles/ChoosePlan";
import { WrapContent } from "../../styles/Validation";
import { HeaderRow } from "../../styles/SelectPlanModification";
import { sendChangePlanNotification } from "../../data/services/person_service";
import { toast, ToastContainer } from "react-toastify";
import { HOME_LOGGED, MYCONTRACTS } from "../../core/app-urls";
import LimitedRelationshipModel from "../../data/models/limitedRelationship";
import LimitedDependent from "../../components/LimitedDependentForm";

interface DependentInput {
  nome: string;
  telefone: string;
  cpf: string;
  email: string;
  relationship: string;
  documentoFrente?: File;
  documentoVerso?: File;
}

export default function SelectDependets() {
  const navigate = useNavigate();
  const [limitedRelationships, setLimitedRelationships] = useState<
    LimitedRelationshipModel[]
  >([]);
  const [dependents, setDependents] = useState<DependentInput[]>([]);
  const [successRequest, setSuccesRequest] = useState(false);
  const location = useLocation();
  const { idContrato, idConvenio, planoSelecionado, contractID, nomePlano } =
    location.state || {};

  useEffect(() => {
    const fetchRelationships = async () => {
      try {
        const { relationships } = await getLimitedRelationships(
          planoSelecionado
        );
        setLimitedRelationships(relationships);
      } catch (error) {
        console.error("Erro ao buscar parentescos:", error);
      }
    };

    fetchRelationships();
  }, []);

  const addDependent = () => {
    setDependents((prev) => [
      ...prev,
      {
        nome: "",
        telefone: "",
        cpf: "",
        email: "",
        relationship: "",
        documentoFrente: undefined,
        documentoVerso: undefined,
      },
    ]);
  };

  const removeDependent = (index: number) => {
    setDependents(dependents.filter((_, i) => i !== index));
  };

  const updateDependent = (
    index: number,
    field: string,
    value: string | File
  ) => {
    setDependents((prev) =>
      prev.map((dependent, i) =>
        i === index ? { ...dependent, [field]: value } : dependent
      )
    );
  };

  const handleGoHome = () => {
    navigate(HOME_LOGGED);
  };

  // const handleSendChangeRequest = async () => {
  //     if (!idContrato || !idConvenio || !planoSelecionado) {
  //         console.error("Dados do contrato ou plano ausentes");
  //         return;
  //     }

  //     const dependentesFormatados = dependents.map((d) => {
  //         const grau = Number(limitedRelationships.find((r) => r.parentesco === d.relationship)?.id_parentesco|| 0);

  //         return {
  //             nome: d.nome,
  //             cpf: d.cpf,
  //             telefone: d.telefone,
  //             email: d.email,
  //             id_contrato: idContrato,
  //             grau_parentesco: grau,
  //         };
  //     });

  //     const success = await sendChangePlanNotification(
  //         idContrato,
  //         planoSelecionado,
  //         idConvenio,
  //         dependentesFormatados
  //     );

  //     if (success) {
  //         toast.success("Alteração solicitada com sucesso!");
  //         setSuccesRequest(true)
  //     } else {
  //         toast.error("Ocorreu um problema ao solicitar a alteração.")
  //     }
  // };

  const validateDependents = () => {
    if (dependents.length === 0 && !isPlanoIndividual) {
      toast.error("Adicione ao menos um dependente.");
      return false;
    }

    for (let i = 0; i < dependents.length; i++) {
      const d = dependents[i];

      if (!d.nome.trim()) {
        toast.error(`Informe o nome do dependente ${i + 1}`);
        return false;
      }

      if (!d.telefone.trim()) {
        toast.error(`Informe o telefone do dependente ${i + 1}`);
        return false;
      }

      if (!d.cpf.trim()) {
        toast.error(`Informe o CPF do dependente ${i + 1}`);
        return false;
      }

      if (!d.email.trim()) {
        toast.error(`Informe o e-mail do dependente ${i + 1}`);
        return false;
      }

      if (!d.relationship) {
        toast.error(`Selecione o grau de parentesco do dependente ${i + 1}`);
        return false;
      }

      if (!d.documentoFrente) {
        toast.error(`Anexe o documento (frente) do dependente ${i + 1}`);
        return false;
      }

      if (!d.documentoVerso) {
        toast.error(`Anexe o documento (verso) do dependente ${i + 1}`);
        return false;
      }
    }

    return true;
  };

  const handleSendChangeRequest = async () => {
    if (!idContrato || !idConvenio || !planoSelecionado) {
      console.error("Dados do contrato ou plano ausentes");
      return;
    }

    if (!validateDependents()) {
      return;
    }

    console.log("Dependents:", dependents);
    console.log("Limited relationships:", limitedRelationships);

    const countByRelationship: Record<string, number> = {};

    for (const dependent of dependents) {
      const relId = String(dependent.relationship);
      countByRelationship[relId] = (countByRelationship[relId] || 0) + 1;
    }

    for (const [relationshipId, count] of Object.entries(countByRelationship)) {
      const relationshipData = limitedRelationships.find(
        (r) => String(r.id_parentesco) === String(relationshipId)
      );
      const limite = relationshipData?.limite ?? Infinity;

      if (count > limite) {
        toast.error(
          `Você excedeu o limite para "${relationshipData?.parentesco}" (limite: ${limite}).`
        );
        return;
      }
    }

    const dependentesFormatados = dependents.map((d) => {
      const grau = Number(
        limitedRelationships.find(
          (r) =>
            r.parentesco!.trim().toLowerCase() ===
            d.relationship.trim().toLowerCase()
        )?.id_parentesco || 0
      );

      return {
        nome: d.nome,
        cpf: d.cpf,
        telefone: d.telefone,
        email: d.email,
        id_contrato: contractID,
        grau_parentesco: 30,
        // grau_parentesco: grau,
      };
    });

    const success = await sendChangePlanNotification(
      contractID,
      planoSelecionado,
      idConvenio,
      dependentesFormatados
    );

    if (success) {
      toast.success("Alteração solicitada com sucesso!");
      setSuccesRequest(true);
    } else {
      toast.error("Ocorreu um problema ao solicitar a alteração.");
    }
  };

  const isPlanoIndividual = (() => {
    if (!nomePlano) return false;

    const name = nomePlano.trim().toLowerCase();
    const endsWithIndividual = name.endsWith("individual");
    const hasExtraAfterIndividual = /individual\s+\S+/i.test(name);

    return endsWithIndividual && !hasExtraAfterIndividual;
  })();

  return (
    <PageContainer>
      <ToastContainer />
      <WrapContent>
        <HeaderRow onClick={() => navigate(MYCONTRACTS)}>
          <IoArrowBackOutline size={24} />
          <h1>
            {isPlanoIndividual
              ? "Plano individual selecionado"
              : "Selecione o(s) dependente(s)"}
          </h1>
        </HeaderRow>
        {(() => {
          const name = nomePlano.trim().toLowerCase();

          const endsWithIndividual = name.endsWith("individual");
          const hasExtraAfterIndividual = /individual\s+\S+/i.test(name);

          if (endsWithIndividual && !hasExtraAfterIndividual) {
            return null;
          }

          if (
            (name.includes("individual + 1 agregado") ||
              name.includes("individual+1agregado") ||
              name.includes("individual+1 agregado")) &&
            dependents.length >= 1
          ) {
            return null;
          }
          return (
            <AddDependentsButton onClick={addDependent}>
              + DEPENDENTE
            </AddDependentsButton>
          );
        })()}

        <DependentsList>
          {dependents.map((dependent, index) => (
            <LimitedDependent
              key={index}
              index={index}
              dependent={dependent}
              onRemove={removeDependent}
              onChange={updateDependent}
              relationships={limitedRelationships}
            />
          ))}
        </DependentsList>

        {!successRequest ? (
          <SendChangeRequestButton onClick={handleSendChangeRequest}>
            Solicitar alteração
          </SendChangeRequestButton>
        ) : (
          <SendChangeRequestButton onClick={handleGoHome}>
            Retornar para a tela inicial
          </SendChangeRequestButton>
        )}
      </WrapContent>
    </PageContainer>
  );
}
